import moment from 'moment';
import apiVersion from '../_helpers/api-version';
import queryString from 'query-string';
import axiosInstance from '../_helpers/axiosConfig';

import { store } from '../_helpers/store';
import { authHeader } from '../_helpers/auth-header'

export const telehealthService = {
  cancel,
  resend,
  getAll,
  getRooms,
  getById,
  schedule,
  sendLink,
  reschedule,
  sendMessage,
  exportToken,
  getVideoToken,
  endTelehealth,
  sendAttachment,
  startTelehealth,
  saveProviderNotes,
  getMessagesByApptId,
};

function startTelehealth(telehealth) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'POST',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/telehealth/${telehealth.id}/start`,
  }).then((response) => {
    return response.data;
  })
}


function saveProviderNotes(telehealth, notes) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'POST',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/telehealth/${telehealth.id}/notes`,
    data: { notes }
  }).then((response) => {
    return response.data;
  })
}

function exportToken(searchParams) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'POST',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/telehealth/export-token`,
    data: { ...searchParams }
  }).then((response) => {
    return response.data;
  })
}

function getById(telehealthId) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'GET',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/telehealth/${telehealthId}`,
  }).then((response) => {
    return response.data;
  })
}

function endTelehealth(telehealthId) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'POST',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/telehealth/${telehealthId}/end`,
  }).then((response) => {
    return response.data;
  })
}

function reschedule(telehealth, date, providerId, locationId, availableOn) {
  const clientId = store.getState().client.id;

  const appointmentDate = moment(date).format('YYYY-MM-DD HH:mm');

  return axiosInstance.request({
    method: 'PATCH',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/telehealth/${telehealth.id}`,
    data: { appointmentDate, providerId, locationId, availableOn }
  }).then((response) => {
    return response.data;
  })
}

function cancel(telehealth) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'DELETE',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/telehealth/${telehealth.id}`,
  }).then((response) => {
    return response.data;
  })
}

function resend(telehealth, phoneNumber, emailAddress) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'POST',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/telehealth/${telehealth.id}/resend`,
    data: { phoneNumber, emailAddress }
  }).then((response) => {
    return response.data;
  })
}

function getVideoToken(telehealthId) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'POST',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/telehealth/${telehealthId}/video`,
  }).then((response) => {
    return response.data;
  })
}

function getRooms(params = {}) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'GET',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/telehealth/rooms?${queryString.stringify(params)}`,
  }).then((response) => {
    return response.data;
  })
}

function getAll(params = {}) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'GET',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/telehealth?${queryString.stringify(params)}`,
  }).then((response) => {
    return response.data;
  })
}

function schedule(telehealth) {
  const clientId = store.getState().client.id;

  const data = { ...telehealth }

  data.emailAddress = telehealth.email;
  data.appointmentDate = moment(telehealth.appointmentDate).format('YYYY-MM-DD HH:mm');
  data.dateOfBirth = moment(telehealth.dateOfBirth).format('YYYY-MM-DD');
  data.availableOn = telehealth.availableOn ? moment(telehealth.availableOn).format('YYYY-MM-DD HH:mm') : null;

  return axiosInstance.request({
    method: 'POST',
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/telehealth`,
    headers: authHeader(),
    data: data
  })
}

function getMessagesByApptId(telehealthId) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'GET',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/telehealth/${telehealthId}/message`,
  }).then((response) => {
    return response.data;
  })
}

function sendMessage(telehealthId, message, socketId = null) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'POST',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/telehealth/${telehealthId}/message`,
    data: { type: 'message', text: message, socketId }
  }).then((response) => {
    return response.data;
  })
}

function sendLink(telehealthId, link, socketId = null) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'POST',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/telehealth/${telehealthId}/message`,
    data: { type: 'link', link, socketId }
  }).then((response) => {
    return response.data;
  })
}

function sendAttachment(telehealthId, file, socketId = null) {
  const clientId = store.getState().client.id;

  const formData = new FormData();
  formData.append('attachment', file, file.name);
  formData.append('type', 'attachment');
  formData.append('socketId', socketId)

  return axiosInstance.request({
    method: 'POST',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/telehealth/${telehealthId}/message`,
    data: formData
  }).then((response) => {
    return response.data;
  })
}